"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var isReactNative = typeof navigator !== "undefined" && typeof navigator.product === "string" && navigator.product.toLowerCase() === "reactnative";

exports.default = isReactNative;


//////////////////
// WEBPACK FOOTER
// ./node_modules/tus-js-client/lib.es5/browser/isReactNative.js
// module id = +49P
// module chunks = 0